import { useState } from "react"
import { TextField, Button, Box, Typography, Paper, Stack } from "@mui/material"

import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"
import useError from "../hooks/Error/useError"
import { useApiService } from "../hooks/Api/useApiService"

const EmailForm = () => {
  const [formData, setFormData] = useState({
    userEmail: "",
    message: "",
  })

  const t = useTranslationSharie()
  const { Error: AlertError, error, success } = useError()
  const { postData } = useApiService()

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const sendEmail = (e) => {
    e.preventDefault()
    postData("sharie/sendemail", {
      from: formData.userEmail,
      text: formData.message,
    }).then((data) => {
      if (data.message === "Successful") {
        success("Email sent successfully!")
        setFormData({ userEmail: "", message: "" })
      } else {
        error(data.message + "Failed to send email. Please try again.")
      }
    })
  }

  return (
    <T>
      <Paper
        elevation={6}
        sx={{
          maxWidth: 520,
          mx: "auto",
          mt: 6,
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            py: 3,
            px: 2,
            textAlign: "center",
            background: "linear-gradient(135deg, #1976d2 0%, #6a1b9a 100%)",
            color: "text.primary",
          }}
        >
          <Typography variant='h5' fontWeight={700} gutterBottom sx={{ letterSpacing: 0.5 }}>
            {t("Have An Idea Or Issue ?")}
          </Typography>
          <Typography variant='body1' sx={{ opacity: 0.9, fontWeight: 400 }}>
            {t("Send Us A Message")}
          </Typography>
        </Box>

        {/* Form */}
        <Box component='form' onSubmit={sendEmail} sx={{ p: 3 }}>
          <TextField
            label={t("Your Email")}
            name='userEmail'
            type='email'
            fullWidth
            margin='normal'
            value={formData.userEmail}
            onChange={handleChange}
            required
          />
          <TextField
            label={t("Message")}
            name='message'
            multiline
            rows={4}
            fullWidth
            margin='normal'
            value={formData.message}
            onChange={handleChange}
            required
          />

          <Stack spacing={2} mt={2}>
            <Button
              type='submit'
              variant='contained'
              fullWidth
              sx={{
                bgcolor: "primary.main",
                "&:hover": { bgcolor: "primary.dark" },
                borderRadius: 2,
                py: 1.2,
                fontWeight: 600,
              }}
            >
              {t("Send Email")}
            </Button>
            <AlertError />
          </Stack>
        </Box>
      </Paper>
    </T>
  )
}

export default EmailForm
